/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

export const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        // Check if the cookie starts with the desired name followed by an equals sign
        if (cookie.startsWith(name + "=")) {
            // Extract the value and decode it
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return "UNAVAILABLE";
};

export const setCookie = (name, value, options) => {
    let expires = "";
    let domain = "";
    let path = "";
    const _days = options?.days;
    const _date = options?.date;
    const _domain = options?.domain;
    const _path = options?.path;
    if (_days) {
        const date = new Date();
        date.setTime(date.getTime() + (_days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        // expires = "; max-age=" + date.toUTCString();
    }
    if (_date) {
        const _date = new Date(_date); // validate is date
        expires = "; expires=" + _date.toUTCString();
    }
    if (_domain) {
        domain = "; domain=" + _domain;
    }
    if (_path) {
        path = "; path=" + _path ?? "/";
    }
    document.cookie = name + "=" + (value || "")
        + expires
        + domain
        + path + "; Secure";
};

export const removeCookie = (name, options) => {
    let domain = "";
    let path = "";
    const _domain = options?.domain;
    const _path = options?.path;
    if (_domain) {
        domain = "; domain=" + _domain;
    }
    if (_path) {
        path = "; path=" + _path ?? "/";
    }
    document.cookie = name + "=; Max-Age=0;"
        + domain
        + path;
};
